import call from '../../assets/call.png'
import place from '../../assets/place.png'
import schedule from '../../assets/schedule.png'
import car from '../../assets/directions_car.png'

export default function InfoWindowContent ({ center, currLocation, handleClinicClick }) {
  const { centerName, address, location, distance, duration, contact, workingHours } = center
  let originLat = ''
  let originLng = ''
  const destinationLat = location.coordinates[1]
  const destinationLng = location.coordinates[0]
  if (currLocation) {
    originLat = currLocation.lat
    originLng = currLocation.lng
  }
  const iPhoneCheck = navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)

  const webDirectionUrl = `https://www.google.com/maps/dir/?api=1&destination=${destinationLat},${destinationLng}&origin=${originLat},${originLng}&travelmode=driving`
  const mobileDirectionUrl = () => {
    window.open(iPhoneCheck ? `maps://?daddr=${destinationLat},${destinationLng}` : `google.navigation:q=${destinationLat},${destinationLng}`, '_blank')
  }

  let workingHoursStructured = 'Not Available'
  if (workingHours && workingHours.start && workingHours.end) {
    workingHoursStructured = workingHours.start + ' - ' + workingHours.end
  }

  if (center) {
    return (
      <div className='infowindow'>
        <ul id='infoData'>
          <li>
            <p id='title'>{centerName}</p>
          </li>

          <li className='mobile-time'>
            <span id='mobile'>
              <img width='17' src={call} alt='call' />
              <p id='mobile'>{contact || 'Not Available'}</p>
            </span>
            <span id='working-hrs'>
              <img width='18' height='16' src={schedule} alt='working hours' />
              <p style={{ marginLeft: '6px' }}>{workingHoursStructured}</p>
            </span>
          </li>
          <li id='address'>
            <img height='20' src={place} alt='address' />
            <p id='address'>{address?.address1 || ''} {address?.address2 || ''} {address?.city || ''}</p>
          </li>
          {distance?.text && duration?.text && (
            <li id='directions-car'>
              <img
                width='17'
                src={car} alt='distance'
              />
              <p style={{ marginLeft: '6px' }}> {distance?.text} ({duration?.text}) </p>
            </li>
          )}
        </ul>

        <button
          data-toggle='tooltip' title='Direction' id='show-directions' className='mobile-directions'
          onClick={() => mobileDirectionUrl()}
          rel='noreferrer' target='_blank'
        >
          <span style={{ fontSize: '40px', color: '#178AD1' }} className='material-symbols-outlined'>assistant_direction</span>
        </button>

        <a
          data-toggle='tooltip' title='Direction' id='show-directions'
          className='web-directions'
          href={webDirectionUrl}
          rel='noreferrer' target='_blank'
        >
          <span style={{ fontSize: '50px', color: '#178AD1' }} className='material-symbols-outlined'>assistant_direction</span>
        </a>

        {/* <button onClick={() => handleClinicClick(null)} className='closeInfoWindow' style={{}}>
          <span className='material-symbols-outlined'>close</span>
        </button> */}
      </div>
    )
  }
}
